module.exports = __webpack_public_path__ + "img/respecth-optima.919efb1b.png";